import React from 'react';
import ReactDOM from 'react-dom';
import Routes from 'routes';
import UiProvider from 'context/UiProvider';
import './index.css';

ReactDOM.render(
  <UiProvider>
    <Routes />
  </UiProvider>,
  document.getElementById('root')
);
